import React from "react";
import MyGiftContent from "widgets/MyGiftContent";

const MyGift: React.FC = () => {
  return (
    <main>
      <MyGiftContent />
    </main>
  );
};

export default MyGift;
